import { Moon, Sun, SunMoon, type LucideIcon } from 'lucide-react';
import type { ThemeMode } from '@/shared/stores';

/**
 * 테마 모드 → 아이콘 SSOT. 사이드바 푸터의 순환 토글과 설정 화면의 테마 선택 카드가 **같은 매핑**을 써야
 * 한 곳만 바뀌어 어긋나는 일이 없다(실제로 시스템 아이콘을 한 번 교체하며 겪은 문제).
 *
 * 아이콘은 해석된 다크 여부가 아니라 **선택된 모드**를 나타낸다 — 해=라이트 · 달=다크 · 해달=시스템.
 * 시스템에 기기 아이콘(`Monitor`)을 쓰면 셋 중 혼자만 "기기" 은유라 같은 줄에서 튄다. `SunMoon`(해+달 합성)은
 * 해/달과 같은 계열이라 "둘 다 = 시스템을 따라감"이 형태만으로 읽힌다.
 *
 * `ThemeMode` 는 **타입만** 가져온다(런타임 의존 없음) — 키 누락을 컴파일러가 막아주는 값만 취한다.
 */
export const THEME_ICON: Record<ThemeMode, LucideIcon> = {
  light: Sun,
  dark: Moon,
  system: SunMoon,
};
